export type AiLibraryPageSizes = {
  models: number;
  tools: number;
  snippets: number;
  skills: number;
  datasets: number;
  judges: number;
};

export const DEFAULT_AI_LIBRARY_PAGE_SIZES: AiLibraryPageSizes = {
  models: 25,
  tools: 50,
  snippets: 50,
  skills: 50,
  datasets: 50,
  judges: 50,
};
